<ion-content class="ion-no-padding">
  <div class="lead-form model-container">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue">Review contacts</ion-title>
        <ion-buttons slot="end" class="ion-no-margin">
          <ion-button (click)="closeModal()" class="unfilled-gray-btn">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content ion-padding">
      <p class="mb-2">{{ extractedContacts.length }} contact(s) found. Review and edit before saving.</p>

      <!-- <small class="text-secondary d-block mb-2">
        Note: Serving Locations (DMC/Agent) and Service Types (Vendor) aren't captured from photos.
        You can add these after saving by editing the contact.
      </small>   -->

      <!-- <small class="text-warning d-block mb-2" *ngIf="extractedContacts.length < selectedFileCount">
        You uploaded {{ selectedFileCount }} photo(s) but only {{ extractedContacts.length }} contact(s) were found —
        some photos may not have been readable. You can upload again for the missing ones.
      </small> -->

      <app-editable-grid [columns]="GRID_COLUMNS" [rows]="extractedContacts"
        [requiredFieldsByType]="REQUIRED_FIELDS_BY_TYPE" (rowsChange)="onGridRowsChange($event)">
      </app-editable-grid>

      <div class="d-flex justify-content-between align-items-center mt-3">
        <small class="text-danger" *ngIf="selectedCount() > 0 && !canSave()">
          Fill all required fields.
        </small>
        <small *ngIf="canSave()">{{ selectedCount() }} of {{ extractedContacts.length }} selected</small>
        <ion-button class="filled-blue-btn" [disabled]="isSaving || !canSave()" (click)="saveAll()">
          <span *ngIf="!isSaving">Save all</span>
          <span *ngIf="isSaving">Saving…</span>
        </ion-button>
      </div>
    </div>

  </div>
</ion-content>